
import { useContext } from 'react';

import { AppContext } from '@r-app/app-context';
import { CreateCountertopPattern } from '../symbols';
import { renderTracking } from '@r-services/render-tracking';
import { RenderCountertop } from '../render/render-countertop';
import { RenderPanels } from '../render/render-panels';

export const DisplayPanelMode = (): React.ReactElement => {
	const { controller } = useContext(AppContext);
	const { kitchen, navigation, navigation: { panelId }} = controller;

	const island = kitchen.design.islands.findById(navigation.islandId);
	const panel = island?.panels.findById(panelId === null ? island.panels.frontPanelId : panelId);
	if (island === null) return <></>;

	renderTracking.incrementRender('DisplayPanel');
	return navigation !== null && kitchen.design.islands.length > 0
		? <g key={kitchen.id} id={`kitchen-${kitchen.id}`}>
			<CreateCountertopPattern {...{ countertop: island.getCountertop(), options: controller.options }} />
			{/* <CreateCornerSymbol {...{ island, islandId: navigation.islandId }} /> */}

			{ /* display panel (panelId = null represents counter) */}
			{navigation.panelId === null
				? <RenderCountertop islandId={ island.id }/>
				: <RenderPanels panelId={ panel.id } islandId={ island.id }/>
			}
		</g>
		: <></>;
};
